import React from 'react';
import DsButton from '../../common/DsButton';
import EventDetailsTimetablePreview from './eventDetailsTimetablePreview';
import { CardListSkeleton } from '../../common/ContentSkeletons';
import { buildEventTicketSalesPath } from '../../../utils/eventTicketSalesNavigation';
import TicketSalesArtistShareSettingsModal from './TicketSalesArtistShareSettingsModal';
import EventGuestTicketManagementModal from './EventGuestTicketManagementModal';
import EventSurveyManagementPanel from './EventSurveyManagementPanel';

export default function EventDetailsOperationalPanels({ view }) {
  const {
    PersonAvatar,
    TASK_PRIORITY_LABELS,
    TASK_PRIORITY_ORDER,
    TicketLineChart,
    activeTimetableTab,
    canEditTicketSales,
    canShareTicketSales,
    canEditGuestTickets,
    canManageGuestTicketAllocations,
    canEditTimetable,
    canViewEventTasks,
    canViewTicketSales,
    canViewGuestTickets,
    canViewSurveys,
    canViewTimetable,
    channelShares,
    ensureEventTaskProject,
    eventId,
    eventReadOnlyTitle,
    eventTaskAllTasksLoading,
    eventTaskCanEdit,
    eventTaskCreating,
    eventTaskError,
    eventTaskInsights,
    eventTaskLoading,
    eventTaskProject,
    eventTaskUpdatingId,
    formatCurrency,
    formatDate,
    grossRevenue,
    handleToggleEventTaskStatus,
    isTaskDoneStatus,
    linePoints,
    navigate,
    netRevenue,
    openTicketSetup,
    openEventTaskDetailModal,
    openTimetableViewer,
    progressPct,
    recentStats,
    setActiveTimetableTab,
    soldTotal,
    ticketCapacityProgress,
    ticketSummary,
    ticketSummaryLoading,
    timetableLoading,
    timetables,
    totalCapacity,
  } = view;
  return (
    <>


            {canViewEventTasks ? (
            <section
              className="event-panel event-task-panel"
              id="event-task-section"
              data-section="event-tasks"
              aria-labelledby="event-task-section-heading"
            >
              <div className="panel-heading">
                <div>
                  <h3 id="event-task-section-heading">イベントタスク</h3>
                </div>
                <div className="panel-actions">
                  {eventTaskProject?.id ? (
                    <DsButton
                      onClick={() =>
                        navigate(`/admin/workspaces/task-management/projects/${encodeURIComponent(eventTaskProject.id)}`)
                      }
                    >
                      このイベントのタスクを開く
                    </DsButton>
                  ) : eventTaskCanEdit ? (
                    <DsButton
                      disabled={eventTaskCreating}
                      loading={eventTaskCreating}
                      onClick={async () => {
                        const project = await ensureEventTaskProject();
                        if (project?.id) {
                          navigate(`/admin/workspaces/task-management/projects/${encodeURIComponent(project.id)}`);
                        }
                      }}
                    >
                      イベントタスクを作成
                    </DsButton>
                  ) : null}
                </div>
              </div>

              <div className="event-task-panel__body">
                {eventTaskLoading ? (
                  <CardListSkeleton rows={3} />
                ) : eventTaskProject ? (
                  <>
                    <div className="event-task-panel__summary">
                      <span className="event-task-panel__kind">イベント連携</span>
                      <h4 className="event-task-panel__title">{eventTaskProject.name || 'イベントタスク'}</h4>
                      <div className="event-task-panel__counts">
                        <span>未完了 {eventTaskInsights.openTaskCount}</span>
                        <span>完了 {eventTaskInsights.doneTaskCount}</span>
                        <span>合計 {eventTaskInsights.totalTaskCount}</span>
                      </div>
                      <div className="event-task-panel__visualGrid">
                        <article className="event-task-panel__visualCard event-task-panel__visualCard--donut">
                          <div className="event-task-panel__donutWrap">
                            <svg viewBox="0 0 36 36" aria-hidden="true">
                              <circle cx="18" cy="18" r="16" />
                              <circle
                                cx="18"
                                cy="18"
                                r="16"
                                className="is-done"
                                strokeDasharray={`${eventTaskInsights.completionRate}, 100`}
                              />
                            </svg>
                            <div className="event-task-panel__donutCenter">
                              <strong>{eventTaskInsights.completionRate}%</strong>
                              <span>完了率</span>
                            </div>
                          </div>
                          <div className="event-task-panel__statusLegend">
                            <span>
                              <i className="is-open" />
                              未完了 {eventTaskInsights.openTaskCount}
                            </span>
                            <span>
                              <i className="is-done" />
                              完了 {eventTaskInsights.doneTaskCount}
                            </span>
                          </div>
                        </article>
                        <article className="event-task-panel__visualCard event-task-panel__visualCard--priority">
                          <div className="event-task-panel__priorityHead">優先度分布（未完了）</div>
                          <div className="event-task-panel__priorityBar" role="img" aria-label="優先度分布">
                            {Object.keys(TASK_PRIORITY_ORDER).map((priorityKey) => {
                              const count = Number(eventTaskInsights.priorityCounts[priorityKey] || 0);
                              const total = Math.max(1, Number(eventTaskInsights.openTaskCount || 0));
                              const width = (count / total) * 100;
                              if (width <= 0) return null;
                              return (
                                <i
                                  key={priorityKey}
                                  className={`is-${priorityKey}`}
                                  style={{ width: `${width}%` }}
                                  title={`${TASK_PRIORITY_LABELS[priorityKey]}: ${count}件`}
                                />
                              );
                            })}
                          </div>
                          <div className="event-task-panel__priorityLegend">
                            {Object.keys(TASK_PRIORITY_ORDER).map((priorityKey) => (
                              <span key={priorityKey}>
                                <i className={`is-${priorityKey}`} />
                                {TASK_PRIORITY_LABELS[priorityKey]}{' '}
                                {Number(eventTaskInsights.priorityCounts[priorityKey] || 0)}
                              </span>
                            ))}
                          </div>
                          <div className="event-task-panel__dueSignals">
                            <span className="is-overdue">期限超過 {eventTaskInsights.overdueCount}</span>
                            <span className="is-today">今日期限 {eventTaskInsights.dueTodayCount}</span>
                            <span className="is-week">7日以内 {eventTaskInsights.dueWeekCount}</span>
                          </div>
                        </article>
                      </div>
                    </div>

                    <div className="event-task-panel__focusHead">
                      <h5>注目タスク</h5>
                      <small>直近締切 / 高優先度のみ表示</small>
                    </div>

                    {eventTaskAllTasksLoading ? (
                      <CardListSkeleton rows={3} />
                    ) : eventTaskInsights.focusTasks.length ? (
                      <>
                        <div className="event-task-panel__focusListHead" aria-hidden="true">
                          <span>完了</span>
                          <span>タスク名</span>
                          <span>担当者</span>
                          <span>期限</span>
                        </div>
                        <ul className="event-task-panel__focusList">
                        {eventTaskInsights.focusTasks.map((task) => (
                          <li key={task.id} className="event-task-panel__focusItem">
                            <div className="event-task-panel__focusRow">
                              <button
                                type="button"
                                className={`event-task-panel__focusDoneBtn ${
                                  isTaskDoneStatus(task.status) ? 'is-done' : ''
                                } is-priority-${task.priorityKey}`}
                                disabled={
                                  !eventTaskCanEdit ||
                                  eventTaskUpdatingId === task.id ||
                                  eventTaskAllTasksLoading ||
                                  eventTaskLoading
                                }
                                onClick={() => {
                                  void handleToggleEventTaskStatus(task);
                                }}
                                aria-label={
                                  isTaskDoneStatus(task.status) ? '未着手に戻す' : '完了にする'
                                }
                                title={
                                  isTaskDoneStatus(task.status) ? '未着手に戻す' : '完了にする'
                                }
                              >
                                <i className="fa-solid fa-check" />
                              </button>
                              <button
                                type="button"
                                className="event-task-panel__focusTitleBtn"
                                onClick={() => openEventTaskDetailModal(task)}
                              >
                                <span className="event-task-panel__focusTitle">
                                  {task.title || 'タイトル未設定'}
                                </span>
                              </button>
                              <span className="event-task-panel__focusAssignee" title={task.assigneeLabel}>
                                {task.assignee ? (
                                  <PersonAvatar
                                    role="admin"
                                    name={task.assigneeLabel}
                                    imageUrl={task.assigneeAvatarUrl}
                                    className="event-task-panel__focusAssigneeAvatar"
                                    size={20}
                                    ariaHidden
                                  />
                                ) : (
                                  <span
                                    className="event-task-panel__focusAssigneeAvatar event-task-panel__focusAssigneeAvatar--empty"
                                    aria-hidden="true"
                                  >
                                    <i className="fa-solid fa-user" />
                                  </span>
                                )}
                                <span>{task.assigneeLabel}</span>
                              </span>
                              <span className={`event-task-panel__focusDue is-${task.dueTone || 'none'}`}>
                                <span className="event-task-panel__focusDueDate">{task.dueLabel}</span>
                                {task.dueHint ? <small>{task.dueHint}</small> : null}
                              </span>
                            </div>
                          </li>
                        ))}
                        </ul>
                      </>
                    ) : (
                      <p className="muted">直近締切または高優先度の未完了タスクはありません。</p>
                    )}
                  </>
                ) : (
                  <div className="event-task-panel__empty">
                    <p className="muted">
                      {eventTaskError || 'このイベントに紐づくタスクプロジェクトはまだ作成されていません。'}
                    </p>
                    {eventTaskCanEdit ? (
                      <DsButton
                        variant="secondary"
                        disabled={eventTaskCreating}
                        loading={eventTaskCreating}
                        onClick={ensureEventTaskProject}
                      >
                        イベントタスクを作成
                      </DsButton>
                    ) : null}
                  </div>
                )}
              </div>
              <div className="panel-footer">
                <DsButton
                  variant="secondary"
                  onClick={() => navigate('/admin/workspaces/task-management/dashboard')}
                >
                  タスク管理へ
                </DsButton>
              </div>
            </section>
            ) : null}

            {canViewTimetable ? (
            <section
              className="event-panel timetable-panel"
              id="timetable-section"
              data-section="timetable"
            >
              <div className="panel-heading">
                <div>
                  <h3>タイムテーブル</h3>
                </div>
                <div className="panel-actions">
                  <DsButton
                    onClick={() => navigate(`/admin/workspaces/event-operations/events/${eventId}/timetable`)}
                    disabled={!canEditTimetable}
                    title={!canEditTimetable ? eventReadOnlyTitle : undefined}
                  >
                    タイムテーブルを設定
                  </DsButton>
                </div>
              </div>
              <div className="timetable-body">
                {timetableLoading ? (
                  <CardListSkeleton rows={3} />
                ) : timetables.length === 0 ? (
                  <p className="muted" style={{ marginTop: 8 }}>
                    まだタイムテーブルがありません。設定ボタンから作成してください。
                  </p>
                ) : (
                  <>
                    <div className="timetable-tabs-simple">
                      {timetables.map((t) => (
                        <button
                          key={t.id}
                          className={`timetable-tab-simple ${t.id === activeTimetableTab ? 'is-active' : ''}`}
                          onClick={() => setActiveTimetableTab(t.id)}
                        >
                          <span className="tab-main">
                            <span className="tab-title-row">
                              <span className="tab-title">{t.title || '無題'}</span>
                              <span
                                className={`tab-share-dot ${t.share_with_artists ? 'is-shared' : 'is-private'}`}
                                aria-label={t.share_with_artists ? '公開中' : '非公開'}
                                title={t.share_with_artists ? '公開中' : '非公開'}
                              />
                            </span>
                            <span className="tab-sub">
                              {t.target_date ? formatDate(t.target_date) : '日付未設定'}
                            </span>
                          </span>
                          <span
                            className="tab-open-link"
                            role="button"
                            tabIndex={0}
                            aria-label="タイムテーブルを別タブで開く"
                            title="タイムテーブルを別タブで開く"
                            onClick={(e) => {
                              e.stopPropagation();
                              openTimetableViewer(t.id);
                            }}
                            onKeyDown={(e) => {
                              if (e.key !== 'Enter' && e.key !== ' ') return;
                              e.preventDefault();
                              e.stopPropagation();
                              openTimetableViewer(t.id);
                            }}
                          >
                            <i className="fa-solid fa-arrow-up-right-from-square" aria-hidden="true"></i>
                          </span>
                        </button>
                      ))}
                    </div>
                    {(() => {
                      const active =
                        timetables.find((t) => t.id === activeTimetableTab) || timetables[0] || null;
                      if (!active) return null;
                      return <EventDetailsTimetablePreview table={active} view={view} />;
                    })()}
                  </>
                )}
              </div>
              {timetables.length ? (
                <div className="panel-footer">
                  <DsButton
                    variant="secondary"
                    onClick={() => openTimetableViewer(activeTimetableTab || timetables[0]?.id)}
                  >
                    当日運用を開く
                  </DsButton>
                </div>
              ) : null}
            </section>
            ) : null}

          {canViewTicketSales ? (
          <section
            className="event-panel ticket-sales-panel"
            id="ticket-sales-section"
            data-section="ticket-sales"
            aria-labelledby="ticket-sales-section-heading"
          >
              <div className="panel-heading">
                <div>
                  <h3 id="ticket-sales-section-heading">券売状況</h3>
                </div>
                <div className="panel-actions">
                  {canViewGuestTickets ? (
                    <EventGuestTicketManagementModal
                      eventUuid={eventId}
                      canView={canViewGuestTickets}
                      canEdit={canEditGuestTickets}
                      canManageAllocations={canManageGuestTicketAllocations}
                    />
                  ) : null}
                  <TicketSalesArtistShareSettingsModal
                    eventUuid={eventId}
                    canShare={canShareTicketSales}
                    PersonAvatar={PersonAvatar}
                  />
                  <DsButton
                    variant="secondary"
                    onClick={() => openTicketSetup()}
                    disabled={!canEditTicketSales}
                    title={!canEditTicketSales ? eventReadOnlyTitle : undefined}
                  >
                    自動入力を設定
                  </DsButton>
                  <DsButton
                    onClick={() => {
                      // 券売状況ページのローカル状態はイベント詳細から入るときにリセットする
                      try {
                        if (typeof window !== 'undefined' && window.sessionStorage) {
                          window.sessionStorage.removeItem(`ticketSalesState:${eventId}`);
                        }
                      } catch (_) {}
                      navigate(buildEventTicketSalesPath(eventId));
                    }}
                    disabled={!canEditTicketSales}
                    title={!canEditTicketSales ? eventReadOnlyTitle : undefined}
                  >
                    券売状況を登録
                  </DsButton>
                </div>
              </div>
              {Number(ticketSummary?.playguide_unmapped_ticket_count || 0) > 0 ? (
                <div className="playguide-ticket-source__state is-error" role="alert">
                  <p>
                    取得済みの外部券種が{Number(ticketSummary.playguide_unmapped_ticket_count)}件未紐付けです。
                    該当する売上は券売状況へまだ反映していません。
                  </p>
                  {canEditTicketSales ? (
                    <DsButton
                      variant="secondary"
                      size="sm"
                      onClick={() => openTicketSetup()}
                    >
                      券種を紐付ける
                    </DsButton>
                  ) : null}
                </div>
              ) : null}
              <div className="ticket-sales-summary">
                {ticketSummaryLoading ? (
                  <CardListSkeleton rows={3} />
                ) : ticketSummary ? (
                  <>
                    <div className="ticket-sales-cards">
                      <div className="ts-card">
                        <div className="ts-card-title">進捗</div>
                        <div className="ts-progress-value">{progressPct}%</div>
                        <div
                          className="ts-progress-bar"
                          role="progressbar"
                          aria-valuemin={0}
                          aria-valuemax={100}
                          aria-valuenow={progressPct}
                        >
                          <div className="ts-progress-fill" style={{ width: `${progressPct}%` }} />
                        </div>
                        <div className="ts-progress-meta">
                          {formatCurrency(soldTotal)} / {formatCurrency(totalCapacity)} 枚
                        </div>
                      </div>
                      <div className="ts-card">
                        <div className="ts-card-title">売上（手数料前）</div>
                        <div className="ts-card-value">¥{formatCurrency(grossRevenue)}</div>
                      </div>
                      <div className="ts-card">
                        <div className="ts-card-title">売上（手数料後）</div>
                        <div className="ts-card-value">¥{formatCurrency(netRevenue)}</div>
                        <div className="ts-card-hint muted small">チケットサイト手数料を控除した概算</div>
                      </div>
                      {Number(ticketSummary.automatic_entry_count || 0) > 0 ? (
                        <div className="ts-card">
                          <div className="ts-card-title">自動取得</div>
                          <div className="ts-card-value">
                            {formatCurrency(ticketSummary.automatic_sold_total || 0)} 枚
                          </div>
                          <div className="ts-card-hint muted small">
                            {Number(ticketSummary.automatic_channel_count || 0)}サイト
                            {ticketSummary.automatic_last_sale_date
                              ? `・最終 ${formatDate(ticketSummary.automatic_last_sale_date)}`
                              : ''}
                          </div>
                        </div>
                      ) : null}
                    </div>

                    {ticketCapacityProgress.length > 0 && (
                      <div className="ts-ticket-progress-block">
                        <div className="ts-ticket-progress-head">チケット種別ごとの販売率</div>
                        <div className="ts-ticket-progress-list">
                          {ticketCapacityProgress.map((t) => (
                            <div className="ts-ticket-progress-row" key={t.id}>
                              <div className="ts-ticket-progress-label">{t.label}</div>
                              <div className="ts-ticket-progress-bar-wrap">
                                <div className="ts-ticket-progress-bar">
                                  <div
                                    className="ts-ticket-progress-fill"
                                    style={{ width: `${Math.min(100, t.pct || 0)}%` }}
                                  />
                                </div>
                                <div className="ts-ticket-progress-meta">
                                  <span>{t.pct != null ? `${t.pct}%` : '— %'}</span>
                                  <span>
                                    {t.sold.toLocaleString()} / {t.capacity.toLocaleString()} 枚
                                  </span>
                                </div>
                              </div>
                            </div>
                          ))}
                        </div>
                      </div>
                    )}

                    <div className="ts-channel-block">
                      <div className="ts-channel-head">販路別 券売枚数分布</div>
                      {channelShares.length ? (
                        <>
                          <div className="ts-channel-bar" role="img" aria-label="販路別売上比率">
                            {channelShares.map((c, idx) => (
                              <div
                                key={idx}
                                className="ts-channel-segment"
                                style={{ width: `${c.percent}%`, background: c.color }}
                                title={`${c.channel_name || '不明'}: ${c.percent}%`}
                              ></div>
                            ))}
                          </div>
                          <div className="ts-channel-list">
                            {channelShares.map((c, idx) => (
                              <div className="ts-channel-row" key={idx}>
                                <span className="ts-channel-dot" style={{ background: c.color }}></span>
                                <span className="ts-channel-name">{c.channel_name || '不明な販路'}</span>
                                <span className="ts-channel-meta">
                                  {c.percent}% ・ {c.sold.toLocaleString()} 枚
                                </span>
                              </div>
                            ))}
                          </div>
                        </>
                      ) : (
                        <p className="muted">販路別の売上データがありません。</p>
                      )}
                    </div>

                    <div className="ts-recent-grid">
                      <div className="ts-card">
                        <div className="ts-card-title">昨日</div>
                        <div className="ts-card-value">{formatCurrency(recentStats.yesterday.sold)} 枚</div>
                        <div className="ts-progress-meta">¥{formatCurrency(recentStats.yesterday.net)}</div>
                      </div>
                      <div className="ts-card">
                        <div className="ts-card-title">今週</div>
                        <div className="ts-card-value">{formatCurrency(recentStats.thisWeek.sold)} 枚</div>
                        <div className="ts-progress-meta">¥{formatCurrency(recentStats.thisWeek.net)}</div>
                      </div>
                      <div className="ts-card">
                        <div className="ts-card-title">先週</div>
                        <div className="ts-card-value">{formatCurrency(recentStats.lastWeek.sold)} 枚</div>
                        <div className="ts-progress-meta">¥{formatCurrency(recentStats.lastWeek.net)}</div>
                      </div>
                    </div>

                    <div className="ts-chart-block">
                      <div className="ts-chart-head">販売枚数の推移</div>
                      <TicketLineChart points={linePoints} />
                    </div>
                  </>
                ) : (
                  <p className="muted">券売データがまだ登録されていません。</p>
                )}
              </div>
              <div className="panel-footer">
                <DsButton
                  variant="secondary"
                  onClick={() => navigate(`/admin/workspaces/event-operations/events/${eventId}/ticket-sales/analytics`)}
                  disabled={!canEditTicketSales}
                  title={!canEditTicketSales ? eventReadOnlyTitle : undefined}
                >
                  詳細分析を見る
                </DsButton>
              </div>
            </section>
          ) : null}
          <EventSurveyManagementPanel
            canView={canViewSurveys}
            eventId={eventId}
            navigate={navigate}
          />
    </>
  );
}
